import eachDayOfInterval from './each-day-of-interval';

export { eachDayOfInterval };

export default eachDayOfInterval;
